export default {"id":"e17c2bb5","attrs":{"viewBox":"0 0 28 28","width":"24","height":"24"}}